import { readAllData, STORES } from "utility"
import { mergeUpsertOffline } from "./crud"

export async function getUsersOffline({ page = 1, limit = 20 } = {}) {
  const users = await readAllData(STORES.USERS)
  const totalItems = users.length
  const startIdx = (page - 1) * limit
  return { data: users.slice(startIdx, startIdx + limit), totalItems }
}

export async function createUserOffline(body) {
  const tempId = crypto.randomUUID()
  const user = {
    ...body,
    id: tempId,
    status: "Pending",
    __offline: true,
  }
  await mergeUpsertOffline(STORES.USERS, user, { markOffline: true })
  // Return WITHOUT status: it's a server-assigned field and the backend rejects it on create
  return { ...body, id: tempId, __offline: true }
}
